enum TastingPlanTypeEnum {
  CUSTOMER_TASTING = 'CUSTOMER_TASTING',
  PITCH_TASTING = 'PITCH_TASTING',
}

export default TastingPlanTypeEnum
